import SearchIcon from '@mui/icons-material/Search'
import {
  Backdrop,
  Box,
  Button,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  styled,
  toggleButtonGroupClasses,
} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AuthContext } from '../../libs/contexts/authContext'

import { Appbox, LabelContainer, StatsNumber, StatsNumberContainer, StyledContainer } from './styledElements'
import { fetchAgentList, agentListSelector } from './tableSlice'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import FilterButtonV2 from '../FilterButtonV2'
import AddIcon from '@mui/icons-material/Add'
import ApplicationManagementTableV2 from './ApplicationManagementTableV2'
import DayUnitToggle from '../dashboardComponents/DayUnitToggle'
import { FetchAgentProducts, FetchApps, FetchFactTableApps, FetchFactTableAppsV2, FetchMetrics } from '../../libs/hooks/queries'

const APPS = [
  {
    arcId: 'ARC7324944940',
    applicationDate: '2022-01-25T14:45:50Z',
    productName: 'Foresters Live Well Plus',
    details: 'F / 60 / SC',
    status: 'Complete',
    appStatus: 'Completed',
    term: 'Completed',
    coverage: 200000,
    paymentPremium: '$35/mo',
    policyNo: '324944940',
    ticketStatus: 'In Progress',
  },
  {
    arcId: 'ARC7324944940',
    applicationDate: '2020-10-26T22:02:03Z',
    productName: 'Foresters Live Well Plus',
    details: 'M / 45 / FL',
    status: 'In Progress',
    appStatus: 'In Progress',
    term: 'Completed',
    coverage: 160000,
    paymentPremium: '$35/mo',
    policyNo: '324944940',
    ticketStatus: 'In Progress',
  },
  {
    arcId: 'ARC7324944940',
    applicationDate: '2023-09-12T05:37:58Z',
    productName: 'Foresters Live Well Plus',
    details: 'F / 60 / SC',
    status: 'Complete',
    appStatus: 'In Progress',
    term: 'Completed',
    coverage: 200000,
    paymentPremium: '$35/mo',
    policyNo: '324944940',
    ticketStatus: 'In Progress',
  },
  {
    arcId: 'ARC7324944940',
    applicationDate: '2022-07-19T21:55:47Z',
    productName: 'Foresters Live Well Plus',
    details: 'F / 60 / SC',
    status: 'Not started',
    appStatus: 'Not started',
    term: 'In Progress',
    coverage: 185000,
    paymentPremium: '$35/mo',
    policyNo: '324944940',
    ticketStatus: 'Closed',
  },
  {
    arcId: 'ARC7324944940',
    applicationDate: '2016-07-05T01:35:21Z',
    productName: 'Foresters Live Well Plus',
    details: 'F / 60 / SC',
    status: 'Not started',
    appStatus: 'Not Started',
    term: 'Completed',
    coverage: 60000,
    paymentPremium: '$35/mo',
    policyNo: '324944940',
    ticketStatus: 'Closed',
  },
]

const ApplicationManagementV2 = () => {
  const { authObj, affiliateCode: affiliateCodeFromContext } = useContext(AuthContext)
  // console.log({ affiliateCodeFromContext, authObj })
  const dispatch = useDispatch()
  const relationalType = authObj?.user?.relationalType
  // const { metricsList } = useSelector(metricsListSelector)
  const { agentList: agentListNoAff } = useSelector(agentListSelector)
  // const { factTableApps } = useSelector(factTableAppsBlobSelector)
  // const { products } = useSelector(productsBlobSelector)
  //   const loading = useSelector(loadingSelector)
  const loading = false
  const [affiliateCode, setAffiliateCode] = useState(affiliateCodeFromContext)
  const [agentList, setAgentList] = useState([])
  const [metricsList, setMetricsList] = useState([])
  const [dayUnit, setDayUnit] = useState('365d')
  const [visibleRows, setVisibleRows] = useState([])
  const [visibleMetrics, setVisibleMetrics] = useState((metricsList || []).find((m) => m.product_id === 1) ?? {})
  const [displayingFtapps, setDisplayingFtapps] = useState(false) // boolean flag for displaying fact table apps
  const [searchBy, setSearchBy] = useState('')

  const [filterBy, setFilterBy] = useState({
    status: 'All',
    ticketStatus: 'All',
    productName: 'All',
  })
  const [boxFilters, setBoxFilters] = useState({
    Applications: '',
    'Identity Verified': '',
    'Underwriting Questions Submitted': '',
    Consent: '',
    Approved: '',
    'Policy Submitted': '',
    'Not Paid': '',
    'Policy Issued': '',
  })

  const { data: appsList, isFetching: fetchingApps } = FetchApps(affiliateCodeFromContext)
  const { data: metricsFromAPI, isFetching: fetchingMetrics } = FetchMetrics(affiliateCodeFromContext)
  const { data: factTableApps, isFetching: fetchingFactTableApps } = FetchFactTableAppsV2(affiliateCodeFromContext)
  const { data: agentProducts, isFetching: fetchingAgentProducts } = FetchAgentProducts(affiliateCodeFromContext)

  useEffect(() => {
    if (!appsList || fetchingApps) return
    setVisibleRows(appsList)
  }, [appsList])

  useEffect(() => {
    if (!metricsFromAPI || fetchingMetrics) return
    console.log({ metricsFromAPI })
    if(authObj) {
      const {user} = authObj;
      if(user) {
        const {firstName, lastName} = user;
        let name = `${firstName} ${lastName}`;
        let summary_data = metricsFromAPI.filter((m) => m.agent_name === name);
        setMetricsList(summary_data)
      }

    }
 
  }, [metricsFromAPI, authObj])

  useEffect(() => {
    if (!agentProducts || fetchingAgentProducts) return
    console.log({ agentProducts })
  }, [agentProducts])

  const productInQuestion = agentProducts?.find((p) => p.productName === filterBy.productName) || {}

  const keyDownHandler = ({ key }) => {
    if (key === 'Enter' && searchBy) {
    }
  }

  useEffect(() => {
    if (filterBy.productName === 'All') {
      setVisibleMetrics(metricsList.find((m) => m.product_id === "1"))
    } else if (filterBy.productName === 'Live Well Plus') {
      setVisibleMetrics(metricsList.find((m) => m.product_id === "4127"))
    } else {
      const found = metricsList.find((m) => String(m.product_id) === productInQuestion.productId) ?? {}
      setVisibleMetrics(found)
    }
  }, [APPS, displayingFtapps, filterBy.productName, metricsList, productInQuestion.productId])

  useEffect(() => {
    if (!searchBy || searchBy.trim() === '') {
      return setVisibleRows(appsList)
    }
    let rows = visibleRows
    if (searchBy) {
      rows = rows.filter(
        (r) =>
          r.arcId.toLowerCase().includes(searchBy.toLowerCase()) ||
          String(r.policyNo).toLowerCase().includes(searchBy.toLowerCase())
      )
    }
    setVisibleRows(rows)
  }, [appsList, searchBy])

  useEffect(() => {
    if (!displayingFtapps || fetchingFactTableApps) return
    setVisibleRows(factTableApps)
  }, [displayingFtapps, factTableApps, fetchingFactTableApps])

  useEffect(() => {
    let newData = Array.isArray(appsList) ? [...appsList] : []
    const currentDate = new Date()
    let subtractDays

    switch (dayUnit) {
      case '7d':
        subtractDays = 7
        break
      case '30d':
        subtractDays = 30
        break
      case '90d':
        subtractDays = 90
        break
      case '365d':
        subtractDays = 365
        break
      default:
        subtractDays = 0
        break
    }

    currentDate.setDate(currentDate.getDate() - subtractDays)
    newData = newData.filter((application) => new Date(application.applicationDate) >= currentDate)
    console.log('number of apps: ', newData.length)
    // newData = newData.filter(boxFilter);
    setVisibleRows(newData)
  }, [dayUnit])

  const boxFilterFunc = (key) => {
    setDisplayingFtapps(true)
    const obj = {
      Applications: `last_${dayUnit}_apps_init`,
      'Identity Verified': `last_${dayUnit}_id_check_pass`,
      'Underwriting Questions Submitted': `last_${dayUnit}_uwq_pass`,
      Consent: `last_${dayUnit}_uw_consent`,
      Approved: `last_${dayUnit}_approved_app`,
      'Policy Submitted': `last_${dayUnit}_policy_submitted`,
      'Not Paid': `last_${dayUnit}_missing_payment`,
      'Policy Issued': `last_${dayUnit}_policy_issued`,
    }
    if (boxFilters[key] === '') {
      const prevObj = { ...boxFilters }
      Object.entries(prevObj).forEach(([k, v]) => {
        if (k !== key) {
          prevObj[k] = ''
        }
      })
      setBoxFilters({ ...prevObj, [key]: obj[key] })
    } else {
      setBoxFilters((prev) => ({
        ...prev,
        [key]: '',
      }))
    }
  }

  const handleFilterBy = (name) => (value) => {
    setFilterBy((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  // const applyFilters = useCallback(() => {
  //   let newData = null
  //   if (!apps) {
  //     return
  //   }

  //   if (displayingFtapps) {
  //     newData = factTableApps.slice()
  //   } else {
  //     newData = Array.isArray(apps) ? [...apps] : []
  //   }

  // const currentDate = new Date()
  // let subtractDays

  // switch (dayUnit) {
  //   case '7d':
  //     subtractDays = 7
  //     break
  //   case '30d':
  //     subtractDays = 30
  //     break
  //   case '90d':
  //     subtractDays = 90
  //     break
  //   case '365d':
  //     subtractDays = 365
  //     break
  //   default:
  //     subtractDays = 0
  //     break
  // }

  // currentDate.setDate(currentDate.getDate() - subtractDays)
  // newData = newData.filter((application) => new Date(application.applicationDate) >= currentDate)

  // // newData = newData.filter(boxFilter);
  // setVisibleRows(newData)
  // }, [apps, displayingFtapps, dayUnit, factTableApps])

  const getMappedData = (dayUnit) => {
    const prefix = `last_${dayUnit}`
    const metricsObj = visibleMetrics ? { ...visibleMetrics } : {}
    console.log({
      Illustrations: metricsObj[`${prefix}_quotes`] || 0,
      Applications: metricsObj[`${prefix}_apps_init`] || 0,
      'Identity Verified': metricsObj[`${prefix}_id_check_pass`] || 0,
      'Underwriting Questions Submitted': metricsObj[`${prefix}_uwq_pass`] || 0,
      Consent: metricsObj[`${prefix}_uw_consent`] || 0,
      Approved: metricsObj[`${prefix}_approved_app`] || 0,
      'Policy Submitted': metricsObj[`${prefix}_policy_submitted`] || 0,
      'Not Paid': metricsObj[`${prefix}_missing_payment`] || 0,
      'Policy Issued': metricsObj[`${prefix}_issued_policies`] || 0,
    })
    return {
      Illustrations: metricsObj[`${prefix}_quotes`] || 0,
      Applications: metricsObj[`${prefix}_apps_init`] || 0,
      'Identity Verified': metricsObj[`${prefix}_id_check_pass`] || 0,
      'Underwriting Questions Submitted': metricsObj[`${prefix}_uwq_pass`] || 0,
      Consent: metricsObj[`${prefix}_uw_consent`] || 0,
      Approved: metricsObj[`${prefix}_approved_app`] || 0,
      'Policy Submitted': metricsObj[`${prefix}_policy_submitted`] || 0,
      'Not Paid': metricsObj[`${prefix}_missing_payment`] || 0,
      'Policy Issued': metricsObj[`${prefix}_issued_policies`] || 0,
    }
  }

  const clearAllFilters = () => {
    Object.keys(filterBy).forEach((key) => {
      filterBy[key] = 'All'
    })
    if (displayingFtapps) {
      setDisplayingFtapps(false)
    }
    setVisibleRows(appsList)
    setBoxFilters((prev) => Object.fromEntries(Object.keys(prev).map((k) => [k, ''])))
  }

  const handleAgentsSearch = (event, value) => {
    if (value != null) {
      setAffiliateCode(value.affCode)
    }
  }

  useEffect(() => {
    let agentNamesAff = []
    if (agentListNoAff.length >= 1) {
      agentNamesAff = agentListNoAff.map((agent) => ({
        label: `${agent.name}`,
        affCode: `${agent.affilateCode}`,
      }))
    }
    setAgentList(agentNamesAff)
  }, [agentListNoAff])

  useEffect(() => {
    if (relationalType !== 87) {
      const agentData = {
        distributorId: '8973',
        agencyId: '1',
      }
      dispatch(fetchAgentList(agentData))
    }
  }, [affiliateCode, dispatch])

  const mappedData = getMappedData(dayUnit)
  const productOptions = agentProducts?.map((p) => p.productName) || []
  const applicationStatusOptions = [
    'Illustration generated',
    'Pending interview(s)',
    'Pending Government ID',
    'Pending ID review – Foresters',
    'RUW',
    'Pending payment details',
    'Pending AML review',
    'Pending signature(s)',
    'Pending agent validation',
    'Pending agent certification',
    'NPW',
    'NPW - Offer expired',
    'NPW - Timeout',
    'NPW - Agent Liscensing',
    'NPW - Payment failure',
    'NPW - Ineligible',
    'NPW - Ineligible (App Questions)',
    'NPW - AIF',
    'NPW - MIB',
    'Decline',
    'Pending Issue',
    'Issued',
  ]
  const ticketStatusOptions = ['All', 'Open', 'In Progress', 'Closed']
  const labels = [
    'Illustrations',
    'Applications',
    'Identity Verified',
    'Underwriting Questions Submitted',
    'Consent',
    'Approved',
    'Policy Submitted',
    'Not Paid',
    'Policy Issued',
  ]

  const filterOptions = createFilterOptions({
    limit: 150,
  })

  const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      margin: theme.spacing(0.5),
      border: 0,
      borderRadius: theme.shape.borderRadius,
      [`&.${toggleButtonGroupClasses.disabled}`]: {
        border: 0,
      },
    },
    [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
      marginLeft: -1,
      borderLeft: '1px solid transparent',
    },
  }))
  const currentLocation = window.location.href
  const newAppLink =
    currentLocation.includes('test') || currentLocation.includes('localhost')
      ? `https://eapp-qa.afficiency.com/?productId=4127&distributorId=8973&affiliateCode=${affiliateCode}&channel=DFL`
      : currentLocation.includes('demo')?
      `https://eapp-demo.afficiency.com/?productId=4127&distributorId=8973&affiliateCode=${affiliateCode}&channel=DFL`
      :`https://lifeeapp.afficiency.com/?productId=4127&distributorId=8973&affiliateCode=${affiliateCode}&channel=DFL`

  return (
    <div style={{ backgroundColor: 'rgba(241, 243, 246, 1)', fontFamily: 'Roboto', minHeight: '100vh' }}>
      <Box sx={{ paddingTop: '50px', px: 1 }}>
        <Grid container rowSpacing={3} mt="12px" pb="12px">
          <Grid item lg={12} sm={12} xs={12}>
            <Grid container px={2} alignItems={'center'}>
              <Grid item lg={9} md={6} sm={6} xs={12}>
                <Typography align="left" variant="h1" style={{ fontSize: '24px', verticalAlign: 'center' }} mb={1}>
                  Application Management
                </Typography>
              </Grid>
              <Grid
                container
                lg={3}
                md={6}
                sm={12}
                xs={12}
                columnSpacing={1}
                rowSpacing={2}
                justifyContent={'flex-end'}
                // sx={{
                //   display: 'flex',
                //   justifyContent: { lg: 'end', md: 'end', sm: 'end', xs: 'center' },
                //   alignItems: 'center',
                // }}
              >
                {authObj.relationalType === 117 && (
                  <Grid item xs={12} md={3}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        // marginRight: { lg: '16px', md: '16px', sm: '16px', xs: '0' },
                      }}
                    >
                      <Autocomplete
                        id="combo-box-demo"
                        options={agentList}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.affCode}>
                              {option.label}
                            </li>
                          )
                        }}
                        onChange={handleAgentsSearch}
                        filterOptions={filterOptions}
                        renderInput={(params) => (
                          <TextField {...params} sx={appManagementStyle.textField} size="small" label="Agents" />
                        )}
                      />
                    </Box>
                  </Grid>
                )}

                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'stretch',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <FilterButtonV2
                      label="Product"
                      options={productOptions}
                      onFilterChange={(selected) => handleFilterBy('productName')(selected)}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'flex-end',
                      width: '100%',
                    }}
                  >
                    <Box
                      maxWidth="100%"
                      sx={{
                        height: { lg: '36.5px', md: '36.5px', sm: '45px', xs: '45px' },
                        // width: { lg: '140px', md: '140px', sm: '100%', xs: '100%' },
                        border: '1px solid #CBD2DB',
                        justifyContent: 'space-between',
                        backgroundColor: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '5px',
                        alignItems: 'center',
                        px: '5px',
                      }}
                    >
                      <Typography fontSize={'14px'} color="#64768C" sx={{ fontSize: '1rem' }}>
                        Show Last:
                      </Typography>
                      <FormControl sx={{ m: 1, minWidth: 80 }} variant="standard" size="small">
                        <Select
                          disableUnderline
                          size="sm"
                          displayEmpty
                          value={dayUnit}
                          onChange={(e) => setDayUnit(e.target.value)}
                        >
                          <MenuItem value="7d">7 Days</MenuItem>
                          <MenuItem value="30d">30 Days</MenuItem>
                          <MenuItem value="90d">90 Days</MenuItem>
                          <MenuItem value="365d">365 days</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  </Box>
                  {/* <DayUnitToggle dayUnit={dayUnit} setDayUnit={setDayUnit} /> */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            width={'100%'}
            container
            xl={12}
            xs={12}
            rowSpacing={2}
            columnSpacing={2}
            mt={3}
            justifyContent={'center'}
            alignItems={'center'}
          >
            {/* <ResponsiveGridBox gap={1} display="grid"> */}
            {labels.map((label, idx) => (
              <Grid key={idx} item lg={1.32} md={3} xs={4}>
                <Appbox
                
                  onClick={() => label !== 'Illustrations' && boxFilterFunc(label)}
                  // style={{ border: label !== 'Quotes' && boxFilters[label] !== '' ? '1px solid grey' : 'none' }}
                >
                  <StatsNumberContainer>
                    <StatsNumber>{mappedData[label]}</StatsNumber>
                  </StatsNumberContainer>
                  <LabelContainer>
                    <Typography fontSize={'14px'}>{label}</Typography>
                  </LabelContainer>
                </Appbox>
              </Grid>
            ))}
            {/* </ResponsiveGridBox> */}
          </Grid>
        </Grid>
        <Typography align="left" fontSize={'12px'} paddingX="16px">
          Data displayed is current as of previous day.
        </Typography>
      </Box>
      <StyledContainer>
        <Grid item lg={12} sm={12} xs={12} sx={{ mt: 2 }}>
          <Grid container spacing={2} height="100%" justifyContent={'space-between'} alignItems={'center'} px={1}>
            <Grid item lg={6} sm={6} xs={6} display="flex" alignItems="center" justifyContent="start">
              <Typography fontSize={'20px'} fontWeight={'600'}>
                Illustrations/Applications
              </Typography>
            </Grid>
            <Grid item lg={2} sm={6} xs={6} display="flex" alignItems="center" justifyContent="end">
              <Tooltip
                title={filterBy.productName === 'All' && 'Please select a product to start a new application.'}
                PopperProps={{
                  style: { pointerEvents: 'none', marginTop: 0, marginLeft: 0 },
                }}
                margin="0px 0px 0px 100px"
              >
                <div>
                  <Button
                    sx={{
                      px: { lg: '18px', md: '18px', xs: '10px' },
                      textTransform: 'none',
                      height: '40px',
                      width: '245px',
                      backgroundColor: '#3C4FB9',
                      color: 'white',
                      borderRadius: '100px',
                      mt: '10px',
                      '&:hover': {
                        backgroundColor: '#9BA5DF',
                        color: 'inherit',
                      },
                      '&:disabled': {
                        backgroundColor: '#C4CAF1',
                        color: 'white',
                        textTransform: 'none',
                      },
                    }}
                    disabled={filterBy.productName === 'All'}
                    onClick={() => window.open(newAppLink, '_blank')}
                    startIcon={<AddIcon />}
                  >
                    New Illustration/Application
                  </Button>
                </div>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={12} sm={12} xs={12}>
          <Grid container alignItems={'flex-end'} justifyContent={'space-between'} rowSpacing={1}>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <TextField
                type="search"
                variant="outlined"
                margin="normal"
                fullWidth
                label="Search for an illustration/application"
                value={searchBy}
                placeholder="Enter a policy number or ARC ID"
                style={{
                  background: 'white',

                  marginBottom: '0px',
                }}
                onChange={(e) => setSearchBy(e.target.value.trim())}
                onKeyDown={keyDownHandler}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            {/* <StyledFilters> */}
            <Grid
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
              // sx={{
              //   display: 'flex',
              //   alignItems: { lg: 'center', md: 'center', sm: 'end', xs: 'end' },
              //   justifyContent: { lg: 'end', md: 'end', sm: 'start', xs: 'start' },
              // }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  justifyContent: { lg: 'flex-end', sm: 'flex-start', xs: 'flex-start' },
                  flexWrap: 'wrap',
                  width: '100%',
                }}
              >
                <Box sx={{ minWidth: '213px' }}>
                  <FilterButtonV2
                    label="Application Status"
                    options={applicationStatusOptions}
                    onFilterChange={(selected) => handleFilterBy('status')(selected)}
                  />
                </Box>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  width={{ lg: 'auto', xs: '100%' }}
                >
                  <FilterButtonV2
                    label="Ticket Status"
                    options={ticketStatusOptions}
                    disabled={true}
                    onFilterChange={(selected) => handleFilterBy('ticketStatus')(selected)}
                  />
                  <Button
                    sx={{
                      fontSize: { lg: '14px', md: '14px', xs: '12px' },
                      width: 'fit-content',
                      height: 'fit-content',
                      fontWeight: '700',
                      textTransform: 'none',
                    }}
                    onClick={clearAllFilters}
                  >
                    Clear All Filters
                  </Button>
                </Stack>
              </Box>
            </Grid>
            {/* </StyledFilters> */}
          </Grid>
        </Grid>
      </StyledContainer>
      <Grid item lg={12} sm={12} xs={12} px={2}>
        <Grid container height="100%">
          <Grid item lg={12} md={12} sm={12} xs={12}>
            {loading || !visibleRows || fetchingFactTableApps ? (
              <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              <ApplicationManagementTableV2
                rowsData={visibleRows}
                filterBy={filterBy}
                boxFilters={boxFilters}
                products={agentProducts || []}
                productInQuestion={productInQuestion}
                displayingFtapps={displayingFtapps}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default ApplicationManagementV2

const appManagementStyle = {
  textField: {
    textAlign: 'left',
    backgroundColor: 'white',
    width: { lg: '238px', md: '238px', sm: '238px', xs: '238px' },
    // margin: '5px',
  },
}
